<script setup>
import { onMounted, computed } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";
import { sendMetrik } from "@/utils/metrika";
import BaseTooltip from "@/components/ui/BaseTooltip.vue";

const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();

const statusApplication = {
	handling: {
		title: "Заявка на рассмотрении",
		desc: "Рассмотрение заявок проходит с 15 по 20 сентября 2025 года",
		icon: "clock",
	},
	accepted: {
		title: "Заявка принята",
		desc: "Вы можете перейти к <span style='color: var(--red)'>подтверждению запуска блюд</span> <br> Срок подачи с 20 сентября по 20 октября 2025 года",
		icon: "success",
	},
	denied: {
		title: "Заявка отклонена",
		desc: "",
		icon: "x",
	},
	extra: {
		title: "Заявка принята",
		desc: "",
		icon: "success",
	},
	won: {
		title: "Финалист",
		desc: "Вы приглашены в Москву в ресторан «Savva» для презентации двух блюд из авторского меню членам жюри. Затраты посещения финала компенсируют Организаторы",
		icon: "badge",
	},
};

const getStatusTitle = (status) => statusApplication[status]?.title || "";
const getStatusDesc = (status) => statusApplication[status]?.desc || "";
const getStatusIcon = (status) => statusApplication[status]?.icon || "";
const getStatusColor = (status) => {
	switch (status) {
		case "handling":
			return "--yellow";
		case "accepted":
			return "--green";
		case "extra":
			return "--green";
		case "won":
			return "--purple";
		case "denied":
			return "--red";
		default:
			return "";
	}
};



const emit = defineEmits(['submitApplication', 'toggleTab']);

const props = defineProps({
	isApplication: {
		type: Boolean,
		default: false
	},
	activeTab: {
		type: Number,
		default: 1,
	},
	isStatusAcceptedAndExtra: {
		type: Boolean,
		default: false
	}
})

const title = computed(() => getStatusTitle(storeRequests.userData.survey.status));
const desc = computed(() => getStatusDesc(storeRequests.userData.survey.status));
const icon = computed(() => getStatusIcon(storeRequests.userData.survey.status));

const isShowDotsAndTab = computed(() => storeSettings.statusSurveyChoose || storeSettings.statusSurveyFinal );



onMounted(() => {
	
});
</script>
<template>
	<div class="filter">
		<div class="filter__title">Подача заявки</div>		
		<button 
			v-if="!storeRequests.userData.survey && storeSettings.statusSurveyRegistration && !props.isApplication"
			@click="emit('submitApplication'), sendMetrik('reachGoal', 'Order')" 
			:disabled="!storeRequests.userData.is_verification" 
			class="btn --middle form__btn"
		>
			Подать заявку
		</button>

		<div class="filter__status" v-if="storeRequests.userData.survey">
			<div :class="['filter__status-title', getStatusColor(storeRequests.userData.survey?.status)]">
				<svg width="18" height="18"><use :href="'#' + icon"></use></svg>
				<span >{{ title }}</span>
			</div>
			<div class="filter__status-desc" v-html="desc" v-if="!isStatusAcceptedAndExtra"></div>
			<div class="filter__status-desc" v-else>Вы можете перейти к <button type="button" @click="emit('toggleTab', 2)" style='color: var(--red)'>подтверждению запуска блюд</button> <br> Срок подачи с 20 сентября по 20 октября 2025 года</div>
		</div>

		<p class="filter__subtitle" v-if="!storeRequests.userData.survey && storeSettings.statusSurveyRegistration && props.isApplication">Заявку необходимо заполнить полностью</p>

		<div class="filter__tabs-inner none-scrollbar" v-if="storeRequests.userData.survey">
			<div class="filter__tabs">

				<button :class="['filter__tab',  { active: activeTab === 1  }]" @click="emit('toggleTab', 1)">Заявка на участие</button>

				<svg v-if="!isShowDotsAndTab" class="filter__tab-dots" width='32' height='4'><use href='#dots'></use></svg>

				<button v-if="!isShowDotsAndTab" :class="['filter__tab', { 'not-active': !isStatusAcceptedAndExtra,  active: activeTab === 2  } ]"  @click="emit('toggleTab', 2)">

					<svg width="16" height="16"><use href="#lock"></use></svg>

					<div class="" v-if="!isStatusAcceptedAndExtra" data-parent-tooltip="tooltip1">
						Подтверждение запуска блюд в заведении
						<BaseTooltip  data-tooltip="tooltip1">Данный этап станет доступен 20 сентября после одобрения заявки</BaseTooltip>
					</div>
					<span v-else>Подтверждение запуска блюд в заведении</span>
				</button>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.filter {
	display: grid;
	gap: 3.4rem;
}
.filter__title {
	font-family: var(--font-family-md);
	font-weight: 500;
	font-size: 3.2rem;
	line-height: 120%;
	text-transform: uppercase;
	color: var(--red);
	@media (max-width: vars.$x480) {
		font-size: 2.4rem;
	}
}
.filter__subtitle {
	font-weight: 400;
	font-size: 2rem;
}
.filter__status {
	display: grid;
	gap: 1.5rem;
}
.filter__status-title {
	width: fit-content;
	display: flex;
	align-items: center;
	gap: 1rem;
	border-radius: 3rem;
	padding: 0.7rem 2rem 1.1rem;
	&.--yellow {
		background: #fff2de;
		color: #db900d;
		border: 1px solid rgba(255, 164, 4, 0.4);
	}
	&.--green {
		background: #f2fff7;
		color: #21c15f;
		border: 1px solid rgba(33, 193, 95, 0.4);
	}
	&.--purple {
		background: #f7e4ff;
		color: #9421c1;
		border: 1px solid rgba(148, 33, 193, 0.4);
	}
	&.--red {
		background: rgba(255, 138, 138, 0.4);
		color: var(--red);
		border: 1px solid rgba(255, 0, 0, 0.4);
	}
	svg {
		width: 1.8rem;
		height: 1.8rem;
		
	}
	span {
		font-weight: 400;
		font-size: 1.6rem;
		line-height: 120%;		
	}
}
.filter__status-desc {
	max-width: 65.4rem;
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 120%;
	color: rgba(0, 0, 0, 0.6);
	span {
		color: var(--red);
	}
}
.filter__tabs-inner {
	width: 100%;
	overflow-x: auto;
	padding-bottom: 50px;
    margin-bottom: -50px;
}
.filter__tabs {
	display: flex;
	align-items: center;
	gap: 2.5rem;
}
.filter__tab {
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	gap: .5rem;

	font-weight: 400;
	font-size: 2.2rem;
	line-height: 120%;
	color: var(--black);
	white-space: nowrap;
	border-bottom: 1px solid transparent;
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
		line-height: 140%;
	}
	&.active {
		color: var(--red);
		border-color: currentColor;
	}
	&.not-active {
		color: #7b7b7b;
		// display: block;
		svg {
			display: block;
		}
	}
	svg {
		width: 1.6rem;
		height: 1.6rem;
		flex-shrink: 0;
		display: none;
	}
}
.filter__tab-dots {
	width: 3.2rem;
	height: .4rem;
	stroke: transparent;
	@media (max-width: vars.$xx) {
		display: none;
	}
}
</style>
